import FormatItalic from "@material-symbols/svg-500/rounded/format_italic.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

export const FormatItalicIcon = memo((props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: FormatItalic });
	return <Icon />;
});
